"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _xstate = require("xstate");
var _propTypes = require("prop-types");
var _AppointmentCancel = _interopRequireDefault(require("./AppointmentCancel"));
var _xstate2 = require("../../lib/constants/xstate");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AppointmentCancelContainer extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleMachineTransition", currentState => {
      this.props.logState(currentState);
    });
    this.service = (0, _xstate.interpret)(props.machine).onTransition(this.handleMachineTransition);
  }
  componentDidMount() {
    this.service.start();
    this.service.send(_xstate2.events.initialized);
  }
  componentWillUnmount() {
    this.service.stop();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_AppointmentCancel.default, {
      createRescheduleLink: this.props.createRescheduleLink,
      service: this.service,
      track: this.props.track,
      searchProvidersLink: this.props.searchProvidersLink
    });
  }
}
(0, _defineProperty2.default)(AppointmentCancelContainer, "propTypes", {
  /* eslint-disable react/forbid-prop-types */

  /**
   * Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider
   * @callback createRescheduleLink
   * @param {number} providerId
   */
  createRescheduleLink: _propTypes.func.isRequired,
  /**
   * devLogger for the state machine to help with debugging
   */
  logState: _propTypes.func,
  /**
   * The appointmentCancelMachine that will handle the logic of the AppointmentCancelComponent
   */
  machine: (0, _propTypes.instanceOf)(_xstate.StateNode).isRequired,
  /**
   * Callback triggered for tracking
   * @callback track
   * @param {string} eventName
   * @param {object} eventData
   */
  track: _propTypes.func.isRequired,
  /**
   * URL link for the `Search Providers` button.
   */
  searchProvidersLink: _propTypes.string.isRequired
});
(0, _defineProperty2.default)(AppointmentCancelContainer, "defaultProps", {
  logState: () => {}
});
var _default = exports.default = AppointmentCancelContainer;
AppointmentCancelContainer.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleMachineTransition",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "currentState",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "AppointmentCancelContainer",
  "props": {
    "logState": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "devLogger for the state machine to help with debugging",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "createRescheduleLink": {
      "description": "Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider\n@callback createRescheduleLink\n@param {number} providerId",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "machine": {
      "description": "The appointmentCancelMachine that will handle the logic of the AppointmentCancelComponent",
      "type": {
        "name": "instanceOf",
        "value": "StateNode"
      },
      "required": true
    },
    "track": {
      "description": "Callback triggered for tracking\n@callback track\n@param {string} eventName\n@param {object} eventData",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "searchProvidersLink": {
      "description": "URL link for the `Search Providers` button.",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};